var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _vm.mostrarInfo
        ? _c(
            "b-row",
            { staticClass: "text-right" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-badge",
                    {
                      attrs: {
                        pill: "",
                        variant: "primary",
                        id: "tooltip-info-1",
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.buscadorPersonasMorales.tooltip.mensajeAyuda"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("b-icon", { attrs: { icon: "question-circle" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.soloPersona ||
                  _vm.soloSector ||
                  _vm.seleccionarSoloSede ||
                  _vm.generarSedeComoSubsede
                    ? _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "tooltip-info-1",
                            triggers: "hover",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _vm.soloPersona == "FISICA"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(".\n            "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.buscaPersonasFisicas"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.soloPersona == "MORAL"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.buscaPersonasMorales"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _vm.soloSector == "PRIVADO"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.buscaSectorPrivado"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.soloSector == "PUBLICO"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.buscaSectorPublico"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.soloSector == "SOCIAL"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.buscaSectorSocial"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.seleccionarSoloSede
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.seleccionaANivelSede"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.generarSedeComoSubsede
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorPersonasMorales.tooltip.representaSedeComoSubsede"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm.$t(
                      "apeironGwApp.buscadorPersonasMorales.mensajes.filtroNoDeRegistro"
                    ),
                    "label-for": "input-no-de-registro",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-no-de-registro",
                      placeholder: _vm.$t(
                        "apeironGwApp.buscadorPersonasMorales.mensajes.filtroNoDeRegistro"
                      ),
                    },
                    on: {
                      focus: function ($event) {
                        _vm.noEncontrado = false
                      },
                    },
                    model: {
                      value: _vm.filtroNoDeRegistro,
                      callback: function ($$v) {
                        _vm.filtroNoDeRegistro = $$v
                      },
                      expression: "filtroNoDeRegistro",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm.$t(
                      "apeironGwApp.buscadorPersonasMorales.mensajes.filtroRfc"
                    ),
                    "label-for": "input-rfc",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-rfc",
                      placeholder: _vm.$t(
                        "apeironGwApp.buscadorPersonasMorales.mensajes.filtroRfc"
                      ),
                    },
                    on: {
                      focus: function ($event) {
                        _vm.noEncontrado = false
                      },
                    },
                    model: {
                      value: _vm.filtroRfc,
                      callback: function ($$v) {
                        _vm.filtroRfc = $$v
                      },
                      expression: "filtroRfc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.soloSector
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.buscadorPersonasMorales.mensajes.filtroSector"
                        ),
                        "label-for": "filtro-sector",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "filtro-sector",
                          options: _vm.opcionesSector,
                        },
                        model: {
                          value: _vm.filtroSector,
                          callback: function ($$v) {
                            _vm.filtroSector = $$v
                          },
                          expression: "filtroSector",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          !_vm.soloPersona
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.buscadorPersonasMorales.mensajes.filtroTipoSolicitud"
                        ),
                        "label-for": "filtro-tipo-solicitud",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "filtro-tipo-solicitud",
                          options: _vm.opcionesTipoSolicitud,
                        },
                        model: {
                          value: _vm.filtrotipoSolicitud,
                          callback: function ($$v) {
                            _vm.filtrotipoSolicitud = $$v
                          },
                          expression: "filtrotipoSolicitud",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "p-2 text-right mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-3",
                  attrs: { disabled: _vm.buscando, variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.buscarDesdePrimerPagina()
                    },
                  },
                },
                [
                  !_vm.buscando
                    ? _c(
                        "div",
                        [
                          _c("b-icon", { attrs: { icon: "search" } }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("global.process.search.action"))
                            ),
                          ]),
                        ],
                        1
                      )
                    : _c("span", [
                        _c("em", [
                          _vm._v(
                            _vm._s(_vm.$t("global.process.search.searching"))
                          ),
                        ]),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-3",
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.limpiarFiltros()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.buscadorPersonasMorales.mensajes.limpiarFiltros"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-alert",
                {
                  staticClass: "mt-3",
                  attrs: { variant: "warning", show: _vm.noEncontrado },
                },
                [_vm._v(_vm._s(_vm.$t("global.process.search.empty")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.buscando,
              expression: "buscando",
            },
          ],
        },
        [
          _c(
            "b-col",
            [
              _c("b-skeleton-table", {
                attrs: {
                  rows: 5,
                  columns: 4,
                  "table-props": { bordered: true, striped: true },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "py-2 area-responsive area-responsive-listado" },
            _vm._l(_vm.personasMorales, function (institucion) {
              return _c(
                "b-row",
                { key: institucion.noDeRegistro },
                [
                  _c(
                    "b-col",
                    [
                      _c("buscador-persona-moral", {
                        attrs: {
                          institucion: institucion,
                          seleccionarSoloSede: _vm.seleccionarSoloSede,
                          generarSedeComoSubsede: _vm.generarSedeComoSubsede,
                        },
                        on: { selected: _vm.emitirSeleccion },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.personasMorales.length > 0
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              id: "per-page-select",
                              options: _vm.pageOptions,
                            },
                            on: { change: _vm.buscarDesdePrimerPagina },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "pie-tabla mt-1", attrs: { md: "8" } },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.buscadorPersonasMorales.mensajes.registrosPorPagina"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.totalRows / _vm.perPage > 1,
                        expression: "totalRows / perPage > 1",
                      },
                    ],
                    attrs: {
                      size: "sm",
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "fill",
                      pills: "",
                    },
                    on: { change: _vm.cambiarPagina },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-right pie-tabla mt-1",
                  attrs: { md: "4" },
                },
                [
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.totalRows) },
                  }),
                  _c("span", {
                    staticClass: "ml-1",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.buscadorPersonasMorales.mensajes.totalDeRegistros"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }